import { createFileRoute } from "@tanstack/react-router";
import { CityPage } from "@/components/CityPage";
import { CITIES, buildCityLdJson } from "@/lib/cities";
import { IMAGES } from "@/lib/images";

const data = CITIES.goteborg;
const URL = "https://bbnnordic.se/solfilm-goteborg";

export const Route = createFileRoute("/solfilm-goteborg")({
  head: () => ({
    meta: [
      { title: "Solfilm Göteborg — offert, kontor, fastighet & 3M Prestige | BBN Nordic" },
      { name: "description", content: `Solfilm i Göteborg för företag, kontor, fastighet och butik. 3M Prestige, energibesparande solfilm och solskyddsfilm på fönster — snabb offert, auktoriserad installatör, 10 års garanti. ${data.reach}.` },
      { name: "keywords", content: "solfilm göteborg, solfilm göteborg företag, offert solfilm göteborg, solfilm kontor göteborg, solfilm fastighet göteborg, solfilm för kontor göteborg, solskyddsfilm göteborg, 3m prestige, 3m prestige solfilm, 3m prestige offert, solfilm installatör, solfilm offert, offert solfilm, offert 3m solfilm, solfilm affärslokal, solfilm butik" },
      { property: "og:title", content: "Solfilm Göteborg — offert & 3M Prestige" },
      { property: "og:description", content: `Auktoriserad 3M-installatör i Göteborg sedan 2008 — solfilm för kontor, fastighet och butik med 10 års garanti. ${data.reach}.` },
      { property: "og:url", content: URL },
      { property: "og:image", content: data.image ?? IMAGES.solfilmHero },
      { property: "og:type", content: "website" },

    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(buildCityLdJson(data)),
      },
    ],
  }),
  component: () => <CityPage data={data} campaignLanding />,
});
